import { rfqMyQuotesFilterStyles } from "@insite/content-library/Widgets/RfqMyQuotes/RfqMyQuotesFilter";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

rfqMyQuotesFilterStyles.customerSelect = {
    css: css`
        padding-right: 34px !important;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    `,
};
